module.exports = __webpack_public_path__ + "mer/img/f.5aa43cd3.png";